import { render, staticRenderFns } from "./LinkWizardCustomize.vue?vue&type=template&id=246b5827&scoped=true&"
import script from "./LinkWizardCustomize.vue?vue&type=script&lang=js&"
export * from "./LinkWizardCustomize.vue?vue&type=script&lang=js&"
import style0 from "./LinkWizardCustomize.vue?vue&type=style&index=0&id=246b5827&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246b5827",
  null
  
)

export default component.exports